import MainLogo from "../../assets/MainLogo.webp";
import { RiFacebookCircleFill, RiInstagramFill } from "react-icons/ri";
import "./socials.css";

const Socials = () => {
  return (
    <section className="social-section">
      <div className="content-padding">
        <div className="social-content">
          <img src={MainLogo} alt="Solo Pints" className="social-logo" />

          <p className="social-eyebrow">Stay in the loop</p>

          <h2>Join us on socials</h2>

          <p className="social-text">
            Follow Solo Pints for new drops, pub-ready fits and behind the
            scenes.
          </p>

          <div className="social-icons">
            <a
              href="https://www.facebook.com/profile.php?id=61586717502694&locale=en_GB"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow Solo Pints on Facebook"
            >
              <RiFacebookCircleFill />
            </a>

            <a
              href="https://www.instagram.com/solopintsclothing/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow Solo Pints on Instagram"
            >
              <RiInstagramFill />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Socials;
